import {Directive, ElementRef, EventEmitter, HostListener, Output} from '@angular/core';
import {rutFormat} from 'rut-helpers';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[appFormatRut]'
})
export class FormatRutDirective {
  @Output()
  valueChanged = new EventEmitter<string>();

  constructor(
    private el: ElementRef
  ) {
  }

  @HostListener('input', ['$event']) onInput() {

    if (this.el.nativeElement.value) {
      this.valueChanged.emit(this.el.nativeElement.value);
      this.el.nativeElement.value = rutFormat(this.el.nativeElement.value);
    }
  }


}
